module.exports = __webpack_public_path__ + "img/primary-discover-card.f93635d2.svg";